export { captureClientPosthogEvent, trackEvent, trackException } from '@/lib/analytics/track';
